<script>
    import { clamp } from 'lodash';
    import { mapState } from 'vuex';
    import Impetus from 'util/dom/impetus';
    import { once } from 'bianco.events';
    import isDesktopMixin from 'framework/mixins/is-desktop';
    import isMountedMixin from '@dreipol/vue-ui/src/mixins/is-mounted';
    import bemMixin from '@dreipol/vue-ui/src/mixins/bem';

    export default {
        mixins: [bemMixin('teaser-news'), isMountedMixin, isDesktopMixin],
        data() {
            return {
                isAnimating: false,
                currentOffset: 0,
            };
        },
        computed: {
            ...mapState('viewport', ['width', 'mq']),
            isAtTheEnd() {
                return this.isMounted && this.currentOffset === this.getMaxScrollValue();
            },
            isAtBeginning() {
                return this.isMounted && this.currentOffset === 0;
            },
            panelStyle() {
                return {
                    transform: `translate3d(${ this.currentOffset * -1 }px, 0, 0)`,
                };
            },
            panelClasses() {
                return [this.bemAdd(this.isAnimating ? 'is-animated' : null, 'list')];
            },
        },
        methods: {
            navigate(event) {
                window.location.href = event.currentTarget.href;
            },
            scrollIntoView({ currentTarget }) {
                this.slide(currentTarget.getBoundingClientRect().left);
            },
            slide(offset) {
                const currentOffset = this.currentOffset + offset;
                this.isAnimating = true;

                // remove the is-animated class at the end of the transition
                once(this.$refs.panel, 'transitionend', () => {
                    this.isAnimating = false;
                });

                this.$nextTick(() => this.move(currentOffset));

                this.setImpetusValue(currentOffset);
            },
            move(offset) {
                const newOffset = this.getNormalizedOffset(offset);

                this.currentOffset = newOffset;
            },
            getNormalizedOffset(offset) {
                return clamp(offset, 0, this.getMaxScrollValue());
            },
            getMaxScrollValue() {
                return this.$refs.panel.scrollWidth - this.$refs.panel.offsetWidth;
            },
            setImpetusValue(offset) {
                if (this.impetus) {
                    this.impetus.setValues(offset, 0);
                }
            },
            goToNext() {
                this.slide(this.$refs.panel.offsetWidth);
            },
            goToPrev() {
                this.slide(-this.$refs.panel.offsetWidth);
            },
            initImpetus() {
                if (this.impetus) {
                    return;
                }

                this.impetus = new Impetus({
                    source: this.$refs.panel,
                    update: this.move,
                    bounce: false,
                    multiplier: -1,
                    boundY: [0, 0],
                    boundX: [0, this.getMaxScrollValue()],
                });
            },
            destroyImpetus() {
                if (this.impetus) {
                    this.impetus.destroy();
                    this.impetus = null;
                }
            },
        },
        watch: {
            width: {
                immediate: false,
                handler(newValue, oldValue) {
                    this.move(this.currentOffset * (0.01 / newValue * oldValue));

                    if (this.impetus) {
                        this.impetus.setBoundX([0, this.getMaxScrollValue()]);
                    }
                },
            },
            isDesktop(value) {
                if (value) {
                    this.initImpetus();
                } else {
                    this.move(0);
                    this.destroyImpetus();
                }
            },
        },
        mounted() {
            if (this.isDesktop) {
                this.initImpetus();
            }
        },
        beforeDestroy() {
            this.destroyImpetus();
        },
    };
</script>
